import { NotifyHelper } from "../../../helpers/toast";
import { eTienDoNhapDiemLopHanhChinhActionIds, eTienDoNhapDiemLopHanhChinhActionsObj } from "../../action-types/tong-hop/ITienDoNhapDiemLopHanhChinhActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const tienDoNhapDiemLopHanhChinhActions = {
    ...generateActions(eTienDoNhapDiemLopHanhChinhActionsObj, "TIEN_DO_NHAP_DIEM_LOP_HANH_CHINH"),
    ...generateActionForKey(eTienDoNhapDiemLopHanhChinhActionsObj, "TIEN_DO_NHAP_DIEM_LOP_HANH_CHINH","THANH_PHAN_LOAD_SUCCESS", () => { NotifyHelper.Success("Tổng hợp thành công") }),
    ...generateActionForKey(eTienDoNhapDiemLopHanhChinhActionsObj, "TIEN_DO_NHAP_DIEM_LOP_HANH_CHINH","THANH_PHAN_LOAD_ERROR", (m) => { NotifyHelper.Error(m) }),

}